import { Select } from "./Select.js";

interface MonthPickerProps {
  /** Months with activity, newest first. */
  months: string[];
  value: string;
  onChange: (month: string) => void;
  format: (month: string) => string;
  label?: string;
}

/**
 * A month is chosen from the months that have data, plus whichever one is
 * being looked at. Offering every month back to 1970 is a scroll through
 * emptiness.
 */
export function MonthPicker({
  months,
  value,
  onChange,
  format,
  label = "Month",
}: MonthPickerProps) {
  const options = months.includes(value) ? months : [value, ...months];

  return (
    <Select aria-label={label} value={value} onChange={(event) => onChange(event.target.value)}>
      {options.map((month) => (
        <option key={month} value={month}>
          {format(month)}
        </option>
      ))}
    </Select>
  );
}
